import { useCfarStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsCfarExerciseComponents } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";

import { AirCfarExerciseGenericActionView } from "../AirCfarExerciseGenericActionView";
import defaultStyles from "./AirCfarExerciseErrorExpired.module.scss";

export interface AirCfarExerciseErrorExpiredProps {
  onContinueClick: () => void;
  onContactSupportClick: () => void;
  onGoBackClick: () => void;
}

export const AirCfarExerciseErrorExpired = (
  props: AirCfarExerciseErrorExpiredProps
) => {
  const [block, cn] = useModuleBEM(
    useCfarStyles(
      CoreFlightsCfarExerciseComponents.AirCfarExerciseErrorExpired,
      defaultStyles
    ),
    CoreFlightsCfarExerciseComponents.AirCfarExerciseErrorExpired
  );
  const { t } = useI18nContext();

  const { onContinueClick, onContactSupportClick, onGoBackClick } = props;

  return (
    <div className={block}>
      <AirCfarExerciseGenericActionView
        title={t("core-flights-cfar.exercise.errorExpired.title")}
        description={t("core-flights-cfar.exercise.errorExpired.description")}
        footerButtons={[
          <button className={cn("continue-button")} onClick={onContinueClick}>
            {t("core-flights-cfar.exercise.errorExpired.continue")}
          </button>,
          <button
            className={cn("contact-support-button")}
            onClick={onContactSupportClick}
          >
            {t("core-flights-cfar.exercise.errorExpired.contactSupport")}
          </button>,
          <button className={cn("go-back-button")} onClick={onGoBackClick}>
            {t("core-flights-cfar.exercise.errorExpired.goBack")}
          </button>,
        ]}
      />
    </div>
  );
};
